@if ($renderImage()) {
	<img
		class="w-full h-full object-cover"
		[ngClass]="$imgClasses()"
		[src]="$src()"
		(error)="onError()"
	/>
} @else {
	<ng-content></ng-content>
}
